import axios from "axios";
import {
  baseApiUrl,
  httpRequest,
  getHttpHeaders,
  getAuthenticatedUserId,
} from "./ApiUtils";

const notificationApiUrl = `${baseApiUrl}/api/Notifications`;

export const getNewNotificationCount = async () => {
  return await httpRequest(getUnreadNotificationsCount.bind(this));
}

export const getUnreadNotifications = async () => {
  return await httpRequest(fetchUnreadNotifications.bind(this));
};

const fetchUnreadNotifications = async () => {
  let config = getHttpHeaders();
  return await axios.get(`${notificationApiUrl}/unread-count`, config);
};

export const getNotifications = async (
  pageNumber,
  pageSize = 30,
  userId = getAuthenticatedUserId()
) => {
  return await httpRequest(
    fetchNotifications.bind(this, pageNumber, pageSize, userId)
  );
};

const fetchNotifications = async (pageNumber, pageSize, userId) => {
  let config = getHttpHeaders();
  return await axios.get(
    `${notificationApiUrl}?UserId=${userId}&PageNumber=${pageNumber}&PageSize=${pageSize}`,
    config
  );
};

export const getNotificationById = async (id) => {
  return await httpRequest(fetchNotificationById.bind(this, id));
};

const fetchNotificationById = async (id) => {
  let config = getHttpHeaders();
  return await axios.get(`${notificationApiUrl}/${id}`, config);
};

export const getNotificationsByUser = async (userId, pageNumber, pageSize) => {
  return await httpRequest(
    fetchNotificationsByUser.bind(this, userId, pageNumber, pageSize)
  );
};

const fetchNotificationsByUser = async (userId, pageNumber, pageSize) => {
  let config = getHttpHeaders();
  return await axios.get(
    `${notificationApiUrl}/User?UserId=${userId}&PageNumber=${pageNumber}&PageSize=${pageSize}`,
    config
  );
};

async function getUnreadNotificationsCount() {
  let config = getHttpHeaders();
  return await axios.get(notificationApiUrl + `/unread-count`, config);
}

export const updateNotification = async (id) => {
  return await httpRequest(putNotification.bind(this, id));
};

const putNotification = async (id) => {
  let config = getHttpHeaders();
  return await axios.put(`${notificationApiUrl}/${id}`, null, config);
};

export const deleteNotification = async (id) => {
  return await httpRequest(fetchDeleteNotification.bind(this, id));
};

const fetchDeleteNotification = async (id) => {
  let config = getHttpHeaders();
  return await axios.delete(`${notificationApiUrl}/${id}`, config);
};

//New additions
export async function addNotification(newNotification) {
  return await httpRequest(postAddNotification.bind(this, newNotification));
}

async function postAddNotification(newNotification) {
  let config = getHttpHeaders();
  return await axios.post(`${notificationApiUrl}`, newNotification, config);
}

export async function deleteIsReadNotifications() {
  return await httpRequest(fetchDeleteIsReadNotifications.bind(this));
}

async function fetchDeleteIsReadNotifications() {
  let config = getHttpHeaders();
  return await axios.delete(`${notificationApiUrl}`, config);
}

export const markNotificationsAsRead = async (userId) => {
  return await httpRequest(putMarkNotificationsAsRead.bind(this, userId));
};

const putMarkNotificationsAsRead = async (userId) => {
  let config = getHttpHeaders();
  return await axios.put(`${notificationApiUrl}/MarkAsRead`, userId, config);
};
